<ion-content class="ion-padding">
  <!-- LOGIN FORM (shows when user is NOT logged in) -->
  <div *ngIf="!isLoggedIn && showLoginForm" class="tab-content" data-testid="login-form">
    <!-- Login Card -->
    <div class="install-box" style="max-width: 400px; margin: 0 auto;">
      <h3 style="margin: 0 0 20px 0; color: #1e40af; display: flex; align-items: center; gap: 8px;">
        <ion-icon name="lock-closed"></ion-icon>
        🔐 Login to ToyBits Admin
      </h3>
      
      <p style="margin: 0 0 20px 0; color: #4b5563;">
        Login with your Facebook page credentials to access the admin dashboard.
      </p>
      
      <!-- Login Form -->
      <form (ngSubmit)="login(loginUsername, loginPassword)">
        <ion-item style="margin-bottom: 16px;">
          <ion-label position="floating">Username</ion-label>
          <ion-input 
            type="text" 
            [(ngModel)]="loginUsername" 
            name="username"
            required
            placeholder="e.g., admin_kenshi"
          ></ion-input>
        </ion-item>
        
        <ion-item style="margin-bottom: 24px;">
          <ion-label position="floating">Password</ion-label>
          <ion-input 
            type="password" 
            [(ngModel)]="loginPassword" 
            name="password"
            required
            placeholder="Enter your password"
          ></ion-input>
        </ion-item>
        
        <!-- Remember Me Checkbox -->
        <ion-item lines="none" style="margin-bottom: 16px;">
          <ion-checkbox slot="start" [(ngModel)]="rememberMe" name="rememberMe"></ion-checkbox>
          <ion-label style="font-size: 0.9rem; color: #4b5563;">
            <ion-icon name="time" style="vertical-align: middle; margin-right: 4px;"></ion-icon>
            Keep me logged in for 7 days
          </ion-label>
        </ion-item>
        
        <!-- Error Message -->
        <div *ngIf="loginError" style="margin-bottom: 16px; padding: 12px; background: #fee2e2; border-radius: 6px; border: 1px solid #fca5a5;">
          <p style="margin: 0; color: #dc2626; font-size: 0.9rem;">
            <ion-icon name="warning" style="vertical-align: middle; margin-right: 4px;"></ion-icon>
            {{ loginError }}
          </p>
        </div>
        
        <!-- Login Button -->
        <ion-button 
          expand="block" 
          color="primary" 
          type="submit"
          [disabled]="loginLoading"
        >
          <ion-icon name="log-in" slot="start" *ngIf="!loginLoading"></ion-icon>
          <ion-spinner name="crescent" slot="start" *ngIf="loginLoading"></ion-spinner>
          {{ loginLoading ? 'Logging in...' : 'Login' }}
        </ion-button>
      </form>
      
      <!-- Demo Credentials -->
      <div style="margin-top: 24px; padding: 16px; background: #f0f9ff; border-radius: 8px; border: 1px solid #bae6fd;">
        <h4 style="margin: 0 0 8px 0; color: #0369a1; font-size: 0.95rem;">
          <ion-icon name="information-circle" style="vertical-align: middle;"></ion-icon>
          Available Pages for Testing:
        </h4>
        <ul style="margin: 0; padding-left: 20px; color: #4b5563; font-size: 0.9rem;">
          <li><strong>admin_kenshi</strong> - KENSHi chatbot (premium)</li>
          <li><strong>admin_iprint</strong> - iPrint (gold)</li>
          <li><strong>admin_masterchili</strong> - MasterChili (gold)</li>
          <li><strong>admin_philcango</strong> - Philcango (premium)</li>
          <li><strong>admin_success_agency</strong> - Success Agency (premium)</li>
        </ul>
        <p style="margin: 8px 0 0 0; color: #4b5563; font-size: 0.85rem;">
          <em>Use any password for testing (API will validate)</em>
        </p>
      </div>
    </div>
    
    <!-- PWA Install Instructions (only show when NOT logged in) -->
    <div class="install-box" *ngIf="showInstallCard" data-testid="install-card">
      <h3 style="margin: 0 0 12px 0; color: #1e40af; display: flex; align-items: center; gap: 8px;">
        <ion-icon name="download"></ion-icon>
        {{ installTitle }}
      </h3>
      
      <div *ngIf="deviceType === 'ios'">
        <p><strong>⚠️ IMPORTANT: Must use Safari browser</strong></p>
        <ol style="margin: 10px 0; padding-left: 20px;">
          <li>Open in <strong>Safari</strong> (not Chrome)</li>
          <li>Tap the <strong>Share</strong> button <span style="color: #4f46e5;">⎋</span></li>
          <li>Scroll down to <strong>"Add to Home Screen"</strong></li>
          <li>Tap <strong>"Add"</strong> in top right</li>
          <li>Launch from home screen</li>
        </ol>
        <p style="margin-top: 8px; font-size: 0.9rem; color: #1e40af;">
          <em>iOS only allows PWA installation via Safari browser</em>
        </p>
      </div>
      
      <div *ngIf="deviceType === 'android'">
        <p><strong>📱 Install on Android (Use Chrome)</strong></p>
        <ol style="margin: 10px 0; padding-left: 20px;">
          <li>Open in <strong>Chrome</strong> browser</li>
          <li>Tap the three dots <strong>⋮</strong> in top right</li>
          <li>Select <strong>"Install app"</strong> or <strong>"Add to Home screen"</strong></li>
          <li>Tap <strong>"Install"</strong> to confirm</li>
          <li>Launch from home screen</li>
        </ol>
      </div>
      
      <div *ngIf="deviceType === 'desktop'">
        <p><strong>💻 Install on Desktop</strong></p>
        <ol style="margin: 10px 0; padding-left: 20px;">
          <li>Use <strong>Chrome</strong> or <strong>Edge</strong> for best experience</li>
          <li>Look for install icon <strong>⬇️</strong> in address bar</li>
          <li>Click <strong>"Install"</strong> button</li>
          <li>Launch from Start Menu or Applications</li>
        </ol>
        <div *ngIf="!canInstall" class="ion-text-center" style="margin: 12px 0; padding: 10px; background: #fef3c7; border-radius: 6px; border: 1px solid #fbbf24;">
          <ion-icon name="information-circle" color="warning"></ion-icon>
          <p style="margin: 4px 0 0 0; color: #92400e; font-size: 0.85rem;">
            <strong>Note:</strong> Install button appears when browser detects PWA is installable.
            You can also check browser menu (⋮) for "Install" option.
          </p>
        </div>
      </div>
      
      <ion-button expand="block" color="primary" (click)="onInstallClick()" *ngIf="!installPromptDismissed && canInstall">
        <ion-icon name="download" slot="start"></ion-icon>
        Install Now
      </ion-button>
      
      <!-- Mobile instruction note -->
      <div *ngIf="!installPromptDismissed && (deviceType === 'ios' || deviceType === 'android') && !canInstall" class="ion-text-center" style="margin: 16px 0; padding: 12px; background: #f0f9ff; border-radius: 8px; border: 1px solid #bae6fd;">
        <ion-icon name="information-circle" color="primary"></ion-icon>
        <p style="margin: 8px 0 0 0; color: #0369a1; font-size: 0.9rem;">
          Follow the instructions above to install via your browser menu
        </p>
      </div>
      
      <ion-button expand="block" fill="outline" (click)="onSkipInstall()" *ngIf="!installPromptDismissed">
        Skip for Now
      </ion-button>
      
      <div *ngIf="installPromptDismissed" class="ion-text-center">
        <ion-icon name="information-circle" color="medium"></ion-icon>
        <p>Installation skipped. You can install later from browser menu.</p>
      </div>
    </div>
    
    <!-- Already Installed Message (shows when app IS installed) -->
    <div class="install-box" *ngIf="showInstalledMessage" style="background: linear-gradient(135deg, #10b981, #059669); color: white;">
      <h3 style="margin: 0 0 12px 0; display: flex; align-items: center; gap: 8px;">
        <ion-icon name="checkmark-circle"></ion-icon>
        ✅ App Installed
      </h3>
      <p style="margin: 0; font-size: 0.95rem;">
        <strong>Great! You're using the installed version.</strong>
      </p>
      <p style="margin: 8px 0 0 0; font-size: 0.9rem; opacity: 0.9;">
        Launch from your home screen for the best experience.
      </p>
    </div>
  </div>

  <!-- ADMIN DASHBOARD (shows when user IS logged in) -->
  <div *ngIf="isLoggedIn && showNavigation" class="tab-content" data-testid="admin-dashboard">
    <!-- Welcome Header -->
    <div style="margin-bottom: 24px; padding: 20px; background: linear-gradient(135deg, #4f46e5, #7c3aed); border-radius: 12px; color: white;">
      <h2 style="margin: 0 0 8px 0; font-size: 1.5rem;">
        👋 Welcome, {{ currentPage?.page_name || 'Admin' }}!
      </h2>
      <p style="margin: 0; opacity: 0.9; font-size: 0.95rem;">
        Tier: <strong>{{ currentPage?.tier || 'Unknown' }}</strong> • 
        Page ID: <strong>{{ currentPage?.page_id || 'N/A' }}</strong>
      </p>
      <ion-button 
        fill="outline" 
        color="light" 
        size="small" 
        style="margin-top: 12px;"
        (click)="logout()"
      >
        <ion-icon name="log-out" slot="start"></ion-icon>
        Logout
      </ion-button>
    </div>
    
    <!-- Tab 1: Home (default) -->
    <div *ngIf="currentTab === 'home'" class="tab-content" data-testid="main-navigation">
      <!-- Dashboard Stats -->
      <ion-card>
        <ion-card-header>
          <ion-card-title>📊 Dashboard</ion-card-title>
        </ion-card-header>
        
        <ion-card-content>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 16px;">
            <div style="text-align: center; padding: 16px; background: #f0f9ff; border-radius: 8px;">
              <div style="font-size: 2rem; color: #4f46e5; margin-bottom: 8px;">6</div>
              <div style="font-size: 0.9rem; color: #4b5563;">Facebook Pages</div>
            </div>
            
            <div style="text-align: center; padding: 16px; background: #f0f9ff; border-radius: 8px;">
              <div style="font-size: 2rem; color: #10b981; margin-bottom: 8px;">3</div>
              <div style="font-size: 0.9rem; color: #4b5563;">Premium Tier</div>
            </div>
            
            <div style="text-align: center; padding: 16px; background: #f0f9ff; border-radius: 8px;">
              <div style="font-size: 2rem; color: #f59e0b; margin-bottom: 8px;">2</div>
              <div style="font-size: 0.9rem; color: #4b5563;">Gold Tier</div>
            </div>
            
            <div style="text-align: center; padding: 16px; background: #f0f9ff; border-radius: 8px;">
              <div style="font-size: 2rem; color: #ef4444; margin-bottom: 8px;">1</div>
              <div style="font-size: 0.9rem; color: #4b5563;">Basic Tier</div>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
      
      <!-- Facebook Pages List -->
      <ion-card>
        <ion-card-header>
          <ion-card-title>📱 Facebook Pages</ion-card-title>
        </ion-card-header>
        
        <ion-card-content>
          <p>Manage your connected Facebook pages:</p>
          
          <ion-button expand="block" color="primary" style="margin-bottom: 16px;">
            <ion-icon name="logo-facebook" slot="start"></ion-icon>
            View All Pages
          </ion-button>
          
          <ion-button expand="block" fill="outline" color="medium">
            <ion-icon name="add-circle" slot="start"></ion-icon>
            Add New Page
          </ion-button>
        </ion-card-content>
      </ion-card>
      
      <!-- API Status Card -->
      <ion-card>
        <ion-card-header>
          <ion-card-title>🔗 API Status</ion-card-title>
        </ion-card-header>
        
        <ion-card-content>
          <ion-item lines="none">
            <ion-label>
              <h2>WisdomVault API</h2>
              <p>https://wisdomvault.welfareph.com/page/api/list/</p>
            </ion-label>
            <ion-badge [color]="apiStatus === 'online' ? 'success' : 'danger'" slot="end">
              {{ apiStatus }}
            </ion-badge>
          </ion-item>
          
          <ion-button expand="block" fill="clear" (click)="testApi()">
            <ion-icon name="wifi" slot="start"></ion-icon>
            Test Connection
          </ion-button>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Tab 2: Components -->
    <div *ngIf="currentTab === 'components'" class="tab-content">
      <ion-card>
        <ion-card-header>
          <ion-card-title>✨ Ionic Components</ion-card-title>
        </ion-card-header>
        
        <ion-card-content>
          <p>Explore the available Ionic components for building your app:</p>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Tab 3: Settings -->
    <div *ngIf="currentTab === 'settings'" class="tab-content">
      <ion-card>
        <ion-card-header>
          <ion-card-title>⚡ App Features</ion-card-title>
        </ion-card-header>
        
        <ion-card-content>
          <ion-item>
            <ion-label>
              <h2>🌙 Dark Mode</h2>
              <p>Toggle between light and dark themes</p>
            </ion-label>
            <ion-toggle [(ngModel)]="isDarkMode" (ionChange)="onThemeToggle()" color="primary"></ion-toggle>
          </ion-item>
        </ion-card-content>
      </ion-card>
    </div>
  </div>
</ion-content>

<!-- Bottom Tab Bar (only show when logged in) -->
<ion-tab-bar *ngIf="isLoggedIn && showNavigation" slot="bottom" data-testid="navigation-tabs">
  <ion-tab-button tab="home" [selected]="currentTab === 'home'" (click)="switchTab('home')" style="--color: #64748b; --color-selected: #4f46e5;">
    <ion-icon name="home" style="font-size: 24px; color: #4f46e5;"></ion-icon>
    <ion-label>Home</ion-label>
  </ion-tab-button>
  
  <ion-tab-button tab="components" [selected]="currentTab === 'components'" (click)="switchTab('components')" style="--color: #64748b; --color-selected: #4f46e5;">
    <ion-icon name="cube" style="font-size: 24px; color: #4f46e5;"></ion-icon>
    <ion-label>Components</ion-label>
  </ion-tab-button>
  
  <ion-tab-button tab="settings" [selected]="currentTab === 'settings'" (click)="switchTab('settings')" style="--color: #64748b; --color-selected: #4f46e5;">
    <ion-icon name="settings" style="font-size: 24px; color: #4f46e5;"></ion-icon>
    <ion-label>Settings</ion-label>
  </ion-tab-button>
</ion-tab-bar>